import { render } from "./details-page.vue?vue&type=template&id=7d6b1f7a&scoped=true"
import script from "./details-page.vue?vue&type=script&lang=js"
export * from "./details-page.vue?vue&type=script&lang=js"

import "./details-page.vue?vue&type=style&index=0&id=7d6b1f7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6b1f7a"]])

export default __exports__